/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import * as S from "../../styles";
import { customArray } from "./service";
import CountryInput from "./country-input";
import "./country-input/styles/bootstrap.css";
import Territories from "./country-input/rawTerritories";

export interface ICountrySelectInputProps {
    id: string;
    label?: string;
    labelColor?: string;
    errorText?: string;
    value?: string;
    disabled?: boolean;
    required?: boolean;
    placeholder?: string;
    onCompChange?(id: string, payload: any): void;
    hasError?: boolean;
    onlyCountries?: string[];
    preferredCountries?: string[];
    excludeCountries?: string[];
}

export const CountrySelectInput = ({
    id,
    label,
    labelColor,
    errorText,
    value,
    required,
    placeholder,
    onCompChange,
    disabled,
    onlyCountries,
    preferredCountries,
    excludeCountries,
    hasError,
}: ICountrySelectInputProps) => {
    const { getCode } = require("iso-3166-1-alpha-2");
    const arrayOfObjects = Territories.map(([countryName, ...rest]) => ({
        [countryName]: rest[1],
    }));
    let iso: any = null;
    if (value) {
        let entry = arrayOfObjects.find((obj) => value in obj);
        if (entry) {
            iso = entry[value];
        }
    }
    const [textValue, setTextValue] = useState(
        value ? (iso ? iso : getCode(value).toLowerCase()) : ""
    );

    // const [textValue, setTextValue] = useState(value ? (getCode(value).toLowerCase()) : "");
    const onChange = (id: string, e: any, country, formattedNumber) => {
        if (disabled) return;

        setTextValue(country?.name);
        onCompChange && onCompChange(id, country?.name);
    };
    // const options = customArray(
    //     {
    //       name: "{countryCode}",
    //       value: "{countryNameEn} {flag}",
    //     },
    //     { filter: validateCountry }
    //   );

    // const validateCountry = (country: any) => {
    //   if (whitelistedCountries?.length) {
    //     const countries = whitelistedCountries?.map((country) =>
    //       country.toLowerCase()
    //     );
    //     return countries.includes(country?.countryCode?.toLowerCase());
    //   }
    //   return true;
    // };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel color={labelColor}>
                    {label}
                    {required && <sup style={{ color: "red" }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip">
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    return (
        <>
            <Form.Group id={id} className="mb-4 formgroup">
                {_renderLabelIf()}
                <InputGroup>
                    <CountryInput
                        className="formcontrol shadow-none"
                        onChange={onChange.bind(null, id)}
                        required={required}
                        country={textValue}
                        value={textValue}
                        placeholder={placeholder}
                        enableSearch={true}
                        disabled={disabled}
                        enableTerritories={true}
                        buttonStyle={{ width: "100%" }}
                        onlyCountries={onlyCountries}
                        preferredCountries={preferredCountries}
                        excludeCountries={excludeCountries}
                        autocompleteSearch={true}
                    />
                    <InputGroup>{_renderErrorTextIf()}</InputGroup>
                </InputGroup>
            </Form.Group>
        </>
    );
};

CountrySelectInput.defaultProps = {
    required: false,
    hasError: false,
    whitelistedCountries: [],
    disabled: false,
};
